module.exports = __webpack_public_path__ + "static/img/05.9939237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/05.jpg
// module id = 427
// module chunks = 1